const namespaced = true
import api from '../../api/vouchers.js';

const state = {
    loadingRequest: false,
    loadinApplication: false,
    evidences: null,
    documents: null,
    entity_id: null,
    loadingEvidences: false,
    authorizations: [],
    request: {
        request_code: null,
        whs_data: {},
        const_center_code: {},
        user_code: null,
        applicant_name: null,
        date: null,
        itm_grp_code: null,
        lines: [],
    },
    voucher: [],
    unitsOfMeasurement: [],
    loadingAuthorizations: false,
    whsList: [],
}
const mutations = {
    SET_REQUEST_VOUCHER(state, request) {
        state.voucher = request;
    },
    SET_LOADING_REQUEST(state, request) {
        state.loadingRequest = request
    },
    SET_LOADING_APPLICATION(state, request) {
        state.loadinApplication = request
    },
    SET_AWS_EVIDENCES(state, request) {
        state.evidences = request;
    },
    SET_EVIDENCES(state, request) {
        state.documents = request;
    },
    SET_ENTITY_ID(state, request) {
        state.entity_id = request;
    },
    SET_UNITS(state, request) {
        state.unitsOfMeasurement = request;
    },
    SET_LOADING_EVIDENCES(state, request) {
        state.loadingEvidences = request;
    },
    SET_AUTHORIZATIONS(state, request) {
        state.authorizations = request;
    },
    SET_LOADING_AUTH(state, request) {
        state.loadingAuthorizations = request;
    },
    SET_WHS_LIST(state, data) {
        state.whsList = data;
    },
}
const actions = {
    getVoucher(context, data) {
        context.commit('SET_LOADING_REQUEST', true);
        return new Promise((resolve) => {
            api.getVoucher(data).then(function (res) {
                context.commit('SET_REQUEST_VOUCHER', res.data.data);
                resolve(res.data.data);
                context.commit('SET_LOADING_REQUEST', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING_REQUEST', false);
            })
        })
    },
    emptyVoucher(context) {
        context.commit('SET_REQUEST_VOUCHER', []);
    },


    store(context, data) {
        context.commit('SET_LOADING_APPLICATION', true);
        return new Promise((resolve, reject) => {
            api.store(data).then(resp => {
                resolve(resp.data);
                context.commit('SET_LOADING_APPLICATION', false);
            }).catch((e) => {
                reject(e)
                context.commit('SET_LOADING_APPLICATION', false);
            })
        });
    },
    getEvidences(context, data) {
        context.commit('SET_LOADING_EVIDENCES', true);
        return new Promise((resolve, reject) => {
            api.getEvidences(data).then(resp => {
                context.commit('SET_EVIDENCES', resp.data);
                resolve(resp.data);
                context.commit('SET_LOADING_EVIDENCES', false);
            }).catch((e) => {
                reject(e);
                context.commit('SET_LOADING_EVIDENCES', false);
            })
        });
    },
    getAwsEvidences(context, data) {
        context.commit('SET_LOADING_EVIDENCES', true);
        return new Promise((resolve, reject) => {
            api.getAwsEvidences(data).then(resp => {
                context.commit('SET_AWS_EVIDENCES', resp.data.data);
                resolve(resp.data.data);
                context.commit('SET_LOADING_EVIDENCES', false);
            }).catch((e) => {
                reject(e);
                context.commit('SET_LOADING_EVIDENCES', false);
            })
        });
    },
    setEntityId(context, data) {
        context.commit('SET_ENTITY_ID', data);
    },
    getUnitsOfMeasurement(context) {
        return new Promise((resolve, reject) => {
            api.getUnitsOfMeasurement().then(resp => {
                context.commit('SET_UNITS', resp.data);
                resolve(resp.data);
            }).catch((e) => {
                reject(e)
            })
        });
    },
    getAuthorizations(context, data) {
        context.commit('SET_LOADING_AUTH', true);
        return new Promise((resolve, reject) => {
            api.getAuthorizations(data).then(resp => {
                context.commit('SET_AUTHORIZATIONS', resp.data.data);
                resolve(resp.data.data);
                context.commit('SET_LOADING_AUTH', false);
            }).catch((e) => {
                reject(e)
                context.commit('SET_LOADING_AUTH', false);
            })
        });
    },
    updateVoucher(context, data) {
        context.commit('SET_LOADING_AUTH', true);
        return new Promise((resolve, reject) => {
            api.updateVoucher(data).then(resp => {
                resolve(resp.data.data);
                //context.dispatch('getAuthorizations');
                context.commit('SET_LOADING_AUTH', false);
            }).catch((e) => {
                context.commit('SET_LOADING_AUTH', false);
                reject(e)
            })
        });
    },
    getWhsList(context) {
        return new Promise((resolve) => {
            api.getWhsList().then(function (res) {
                context.commit('SET_WHS_LIST', res.data);
                resolve(res.data);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
            })
        })
    },
    updateReqNumber(context, data) {
        context.commit('SET_LOADING_AUTH', true);
        return new Promise((resolve, reject) => {
            api.updateReqNumber(data).then(resp => {
                resolve(resp.data.data);
                //context.dispatch('getAuthorizations');
                context.commit('SET_LOADING_AUTH', false);
            }).catch((e) => {
                context.commit('SET_LOADING_AUTH', false);
                reject(e)
            })
        });
    },
}
const getters = {
    getRequest(state) {
        return state.request;
    },
    getListRequest(state) {
        return state.voucher;
    },
    getRequestCode(state) {
        return state.request_code;
    }

}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}